import throttle from 'lodash-es/throttle';

function setUpScrollIndicator(scrollElementSelector) {
  const $selector = $(scrollElementSelector);
  const $track = $('.scroll-indicator__track');
  const $bar = $('.scroll-indicator__bar');
  const $overlay = $('.gradient-overlay');

  if (!$selector.length > 0) return;

  let clientWidth;
  let scrollWidth;

  function measure() {
    clientWidth = $selector[0].clientWidth;
    scrollWidth = $selector[0].scrollWidth;

    if (clientWidth === scrollWidth) {
      $track.hide();
      $overlay.hide();
      return;
    }

    $track.show();
    $overlay.show();
    $bar.width(`${(clientWidth / scrollWidth) * 100}%`);
    setBarLeft();
  }

  function setBarLeft() {
    const scrollLeft = $selector[0].scrollLeft;
    const percentMultiplier = clientWidth / scrollWidth;
    const leftPixelOffset = scrollLeft * percentMultiplier;

    const percentOffset = scrollLeft / scrollWidth;

    $bar.css('left', `${percentOffset * 100}%`);
  }

  window.addEventListener('resize', throttle(measure, 100));
  $selector.scroll(setBarLeft);

  measure();

  function checkScrollWidth() {
    if (scrollWidth !== $selector[0].scrollWidth) measure(); // eslint-disable-line curly
    window.requestAnimationFrame(checkScrollWidth);
  }

  window.requestAnimationFrame(checkScrollWidth);
}

export default setUpScrollIndicator;